module.exports = function() {
  return new Worker(__webpack_public_path__ + "web-worker.088f1aeb3f845d1f56a9.js");
};